import React from "react";
import { FieldRenderer } from "../form/FieldRenderer";
import { Field, Input } from "../form/atoms";
import type { PaymentDetailsProps } from "./types";

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  paymentTop,
  paymentDates,
  discountError,
  afterDiscount,
  discountRegister,
}) => {
  const modifiedTop = paymentTop
    .map((f) => (f.name === "total_paid_amount" ? { ...f, disabled: true } : f))
    .filter((f) =>
      ["payment_mode", "transaction_ref", "total_paid_amount"].includes(f.name)
    );

  return (
    <div className="mt-12 rounded-sm border border-[#E6E8EE] bg-white p-6 shadow-[0_8px_24px_rgba(0,0,0,0.06)]">
      <h3 className="text-[15px] font-bold text-[#2B2B2B]">Payment Details</h3>

      <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-4">
        {modifiedTop.map((f) => (
          <FieldRenderer key={f.name} cfg={f} />
        ))}

        <Field label="Discount(%)" error={discountError}>
          <Input
            type="number"
            inputMode="decimal"
            autoComplete="off"
            {...discountRegister}
          />
          <div className="mt-2 text-[12.5px] font-semibold text-[#2B2B2B]">
            After discount: <span className="font-bold">${afterDiscount}</span>
          </div>
        </Field>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4">
        {paymentDates.map((f) => (
          <FieldRenderer key={f.name} cfg={f} />
        ))}
      </div>
    </div>
  );
};

export default PaymentDetails;
